"use client";
import React from "react";
import { Avatar, Button, Grid, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useBrowse } from "../../lib/hooks";
import { getLocationBookingPath } from "@/consts/serviceHubs";

const { useBreakpoint } = Grid;

/**
 * Mobile-only card shown when a map pin is tapped (the list is hidden in map
 * view). Displays the location avatar, name, address, and an Enter button to
 * the location detail page.
 */
const SelectedPlaceCard = () => {
  const screens = useBreakpoint();
  const { place, clearPlace, isMapView, serviceSlug } = useBrowse();

  if (screens.md || !isMapView || !place) return null;

  return (
    <div
      className="selected-place-card"
      role="dialog"
      aria-label={`${place.name} details`}
    >
      <button
        type="button"
        className="selected-place-card-close"
        onClick={clearPlace}
        aria-label={`Close ${place.name} details`}
      >
        <CloseOutlined />
      </button>

      <div className="selected-place-card-body">
        <Avatar
          shape="square"
          src={place.image}
          size={64}
          alt={`${place.name} thumbnail`}
        />
        <div className="selected-place-card-info">
          <Typography.Text strong className="selected-place-card-name">
            {place.name}
          </Typography.Text>
          <Typography.Text type="secondary" className="is-size-7">
            {place.address}
          </Typography.Text>
        </div>
      </div>

      <Button
        href={getLocationBookingPath(place.pathId, serviceSlug)}
        type="primary"
        block
        aria-label={`View ${place.name} location`}
      >
        View location
      </Button>
    </div>
  );
};

export default SelectedPlaceCard;
